import { useAuthStore } from '@/entities/auth'
import { useNotificationsStore } from '@/entities/notifications'
import { useStoresStore } from '@/entities/store'

/**
 * Reset all Pinia stores to their initial state
 * This should be called during logout to ensure a clean state
 * Note: Query cache clearing should be handled in the component that calls this function
 */
export function resetAllStores() {
  try {
    // Reset auth store
    const authStore = useAuthStore()
    authStore.clearProfile()

    // Reset stores store
    const storesStore = useStoresStore()
    storesStore.resetStore()

    // Reset notifications store
    const notificationsStore = useNotificationsStore()
    notificationsStore.clearNotifications()
  }
  catch (error) {
    console.error('Error resetting stores:', error)
  }
}
